const middleware = {}

middleware['auth'] = require('../middleware/auth.js');
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['biometry'] = require('../middleware/biometry.js');
middleware['biometry'] = middleware['biometry'].default || middleware['biometry']

middleware['client-edit'] = require('../middleware/client-edit.js');
middleware['client-edit'] = middleware['client-edit'].default || middleware['client-edit']

middleware['flow'] = require('../middleware/flow.js');
middleware['flow'] = middleware['flow'].default || middleware['flow']

middleware['redirect'] = require('../middleware/redirect.js');
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

export default middleware
